import React, {Component} from 'react';
import Alert from "react-bootstrap/Alert";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

class TournamentDetailDesc extends Component {

	constructor(props) {
		super(props);
		this.state = {
		};
		console.log(this.props)
	}

	componentDidMount() {
	}

	render() {

		return (
			<div className="offset-lg-2 col-lg-8">

				<div>
					{
						(this.props.data.desc) ?
						(this.props.data.desc).split('\n').map((line, idx) => {
							return (<span key={idx}>{line}<br/></span>)
						}) : ''
					}
				</div>

				<div>
					<div className="mt-20">
						<h5 className="mb-15">Prize</h5>
					</div>
					<Paper className="p-3">{this.props.data.desc_prize}</Paper>
				</div>

				<div>
					<div className="mt-20">
						<h5 className="mb-15">Rules</h5>
					</div>
					<Paper className="p-3">길이, 무게 : 합산 (3마리)</Paper>
					{/*<Alert variant="info">*/}
					{/*	길이, 무게 : 합산 (3마리)*/}
					{/*</Alert>*/}
				</div>

				<div>
					<div className="mt-20">
						<h5 className="mb-15">Sponsors</h5>
					</div>
					<Paper className="p-3">길이, 무게 : 합산 (3마리)</Paper>
				</div>
			</div>
		);
	}
}

export default TournamentDetailDesc;
